/* Canvono baked browse-taxonomy snapshot (window.CVN_TAXONOMY).
 * Generated by storefront_publishing/scripts/build_filter_assets.py from
 * storefront_publishing/taxonomy_registry.json. Do NOT hand-edit -- regenerate.
 * FALLBACK ONLY: the live list is the shop metafield custom.taxonomy (taxonomy_sync.py),
 * printed in the <head> by snippets/cvn-taxonomy-data; this assigns only when that is absent.
 * Consumed by cvn-filter.js: groups[{s,n}] niches[{s,n,g}] micros[{s,n,ni}]
 * vibes[{s,n,c}] vibecats[{s,n}] (s=slug, n=name, g=group, ni=niche, c=vibecat). */
window.CVN_TAXONOMY = window.CVN_TAXONOMY || {
 "groups": [
  {
   "s": "sports-fitness",
   "n": "Sports & Fitness"
  },
  {
   "s": "outdoors",
   "n": "Outdoors & Adventure"
  },
  {
   "s": "hobbies",
   "n": "Hobbies & Makers"
  },
  {
   "s": "food-drink",
   "n": "Food & Drink"
  },
  {
   "s": "professions",
   "n": "Professions & Trades"
  },
  {
   "s": "animals-pets",
   "n": "Animals & Pets"
  },
  {
   "s": "fandom-culture",
   "n": "Fandom & Culture"
  },
  {
   "s": "life-identity",
   "n": "Life & Identity"
  },
  {
   "s": "seasonal",
   "n": "Seasonal"
  }
 ],
 "niches": [
  {
   "s": "run-club",
   "n": "Run Club",
   "g": "sports-fitness"
  },
  {
   "s": "pickleball",
   "n": "Pickleball",
   "g": "sports-fitness"
  },
  {
   "s": "disc-golf",
   "n": "Disc Golf",
   "g": "sports-fitness"
  },
  {
   "s": "gym-rat",
   "n": "Gym Rat",
   "g": "sports-fitness"
  },
  {
   "s": "golf",
   "n": "Golf",
   "g": "sports-fitness"
  },
  {
   "s": "pilates",
   "n": "Pilates",
   "g": "sports-fitness"
  },
  {
   "s": "rock-climbing",
   "n": "Rock Climbing",
   "g": "sports-fitness"
  },
  {
   "s": "hybrid-athlete",
   "n": "Hybrid Athlete",
   "g": "sports-fitness"
  },
  {
   "s": "fantasy-football",
   "n": "Fantasy Football",
   "g": "sports-fitness"
  },
  {
   "s": "bjj",
   "n": "Brazilian Jiu-Jitsu",
   "g": "sports-fitness"
  },
  {
   "s": "camping",
   "n": "Camping & Outdoors",
   "g": "outdoors"
  },
  {
   "s": "fishing",
   "n": "Fishing & Angler",
   "g": "outdoors"
  },
  {
   "s": "birdwatching",
   "n": "Birdwatching",
   "g": "outdoors"
  },
  {
   "s": "mushroom-foraging",
   "n": "Mushroom Foraging",
   "g": "outdoors"
  },
  {
   "s": "astronomy",
   "n": "Amateur Astronomer",
   "g": "outdoors"
  },
  {
   "s": "scuba-diving",
   "n": "Scuba & Freediving",
   "g": "outdoors"
  },
  {
   "s": "metal-detecting",
   "n": "Metal Detecting",
   "g": "outdoors"
  },
  {
   "s": "ski-snowboard",
   "n": "Ski & Snowboard",
   "g": "outdoors"
  },
  {
   "s": "crochet-fiber",
   "n": "Crochet & Fiber Arts",
   "g": "hobbies"
  },
  {
   "s": "sourdough",
   "n": "Sourdough & Baking",
   "g": "hobbies"
  },
  {
   "s": "houseplant",
   "n": "Houseplant Parent",
   "g": "hobbies"
  },
  {
   "s": "beekeeping",
   "n": "Backyard Beekeeper",
   "g": "hobbies"
  },
  {
   "s": "vegetable-gardening",
   "n": "Vegetable Gardener",
   "g": "hobbies"
  },
  {
   "s": "chicken-keeping",
   "n": "Backyard Chicken Keeper",
   "g": "hobbies"
  },
  {
   "s": "woodworking",
   "n": "Woodworking",
   "g": "hobbies"
  },
  {
   "s": "pottery-ceramics",
   "n": "Pottery & Ceramics",
   "g": "hobbies"
  },
  {
   "s": "coffee-snob",
   "n": "Coffee Snob",
   "g": "food-drink"
  },
  {
   "s": "bbq",
   "n": "BBQ & Grill Master",
   "g": "food-drink"
  },
  {
   "s": "matcha",
   "n": "Matcha Lover",
   "g": "food-drink"
  },
  {
   "s": "teacher",
   "n": "Teacher",
   "g": "professions"
  },
  {
   "s": "nurse",
   "n": "Nurse",
   "g": "professions"
  },
  {
   "s": "electrician",
   "n": "Electrician & Trades",
   "g": "professions"
  },
  {
   "s": "hairstylist",
   "n": "Hairstylist & Cosmetologist",
   "g": "professions"
  },
  {
   "s": "firefighter",
   "n": "Firefighter",
   "g": "professions"
  },
  {
   "s": "vet-tech",
   "n": "Vet Tech",
   "g": "professions"
  },
  {
   "s": "real-estate",
   "n": "Real Estate Agent",
   "g": "professions"
  },
  {
   "s": "flight-attendant",
   "n": "Flight Attendant",
   "g": "professions"
  },
  {
   "s": "software-dev",
   "n": "Software Developer & IT",
   "g": "professions"
  },
  {
   "s": "slp",
   "n": "Speech-Language Pathologist",
   "g": "professions"
  },
  {
   "s": "dental-hygienist",
   "n": "Dental Hygienist",
   "g": "professions"
  },
  {
   "s": "librarian",
   "n": "School Librarian",
   "g": "professions"
  },
  {
   "s": "doula-midwife",
   "n": "Doula & Midwife",
   "g": "professions"
  },
  {
   "s": "line-cook",
   "n": "Line Cook & BOH",
   "g": "professions"
  },
  {
   "s": "ems-paramedic",
   "n": "EMS Paramedic & EMT",
   "g": "professions"
  },
  {
   "s": "physical-therapist",
   "n": "Physical Therapist & DPT",
   "g": "professions"
  },
  {
   "s": "equestrian",
   "n": "Equestrian & Barn Life",
   "g": "animals-pets"
  },
  {
   "s": "reef-tank",
   "n": "Reef Tank",
   "g": "animals-pets"
  },
  {
   "s": "romantasy",
   "n": "Romantasy & Spicy Reader",
   "g": "fandom-culture"
  },
  {
   "s": "true-crime",
   "n": "True Crime Fan",
   "g": "fandom-culture"
  },
  {
   "s": "tabletop-rpg",
   "n": "Tabletop RPG",
   "g": "fandom-culture"
  },
  {
   "s": "vinyl-records",
   "n": "Vinyl Record Collector",
   "g": "fandom-culture"
  },
  {
   "s": "marching-band",
   "n": "Marching Band",
   "g": "fandom-culture"
  },
  {
   "s": "mental-health",
   "n": "Mental Health & Self-Care",
   "g": "life-identity"
  },
  {
   "s": "girl-dad",
   "n": "Girl Dad",
   "g": "life-identity"
  },
  {
   "s": "sober-recovery",
   "n": "Sober & Recovery",
   "g": "life-identity"
  },
  {
   "s": "cool-aunt",
   "n": "Cool Aunt",
   "g": "life-identity"
  },
  {
   "s": "motorcycle",
   "n": "Motorcycle Rider & Cafe Racer",
   "g": "life-identity"
  },
  {
   "s": "halloween",
   "n": "Halloween",
   "g": "seasonal"
  },
  {
   "s": "christmas",
   "n": "Christmas",
   "g": "seasonal"
  },
  {
   "s": "sweater-weather",
   "n": "Fall & Sweater Weather",
   "g": "seasonal"
  },
  {
   "s": "dog",
   "n": "Dog",
   "g": "animals-pets"
  },
  {
   "s": "cat",
   "n": "Cat",
   "g": "animals-pets"
  },
  {
   "s": "hunting",
   "n": "Hunting",
   "g": "outdoors"
  },
  {
   "s": "hockey",
   "n": "Hockey",
   "g": "sports-fitness"
  },
  {
   "s": "cycling",
   "n": "Cycling",
   "g": "sports-fitness"
  },
  {
   "s": "remote-worker",
   "n": "Remote Worker",
   "g": "professions"
  },
  {
   "s": "ai-enthusiast",
   "n": "AI Enthusiast",
   "g": "life-identity"
  },
  {
   "s": "agentic-ai-engineer",
   "n": "Agentic AI Engineer",
   "g": "professions"
  },
  {
   "s": "mahjong",
   "n": "Mahjong",
   "g": "fandom-culture"
  },
  {
   "s": "thanksgiving",
   "n": "Thanksgiving",
   "g": "seasonal"
  }
 ],
 "micros": [
  {
   "s": "dog-mom",
   "n": "Dog Mom",
   "ni": "dog"
  },
  {
   "s": "cat-mom",
   "n": "Cat Mom",
   "ni": "cat"
  },
  {
   "s": "hunting-deer",
   "n": "Deer Season & Hunting",
   "ni": "hunting"
  },
  {
   "s": "hockey-beer-league",
   "n": "Beer League Hockey",
   "ni": "hockey"
  },
  {
   "s": "cycling-road",
   "n": "Road Cycling",
   "ni": "cycling"
  },
  {
   "s": "birdwatching-cardinal",
   "n": "Northern Cardinal",
   "ni": "birdwatching"
  },
  {
   "s": "birdwatching-owl",
   "n": "Owls",
   "ni": "birdwatching"
  },
  {
   "s": "birdwatching-songbird",
   "n": "Songbirds",
   "ni": "birdwatching"
  },
  {
   "s": "nurse-night-shift",
   "n": "Night Shift",
   "ni": "nurse"
  },
  {
   "s": "rock-climbing-bouldering",
   "n": "Bouldering",
   "ni": "rock-climbing"
  },
  {
   "s": "woodworking-hand-tools",
   "n": "Hand Tools",
   "ni": "woodworking"
  },
  {
   "s": "dog-dad",
   "n": "Dog Dad",
   "ni": "dog"
  },
  {
   "s": "hockey-mom",
   "n": "Hockey Mom",
   "ni": "hockey"
  }
 ],
 "vibes": [
  {
   "s": "coffee",
   "n": "Coffee & caffeine",
   "c": "subject"
  },
  {
   "s": "humor",
   "n": "Humor",
   "c": "mood"
  },
  {
   "s": "retro",
   "n": "Retro / vintage",
   "c": "style"
  },
  {
   "s": "parent",
   "n": "Parent life",
   "c": "subject"
  },
  {
   "s": "dark",
   "n": "Dark & moody",
   "c": "mood"
  },
  {
   "s": "cozy",
   "n": "Cozy",
   "c": "mood"
  },
  {
   "s": "beer",
   "n": "Beer & brewery",
   "c": "subject"
  },
  {
   "s": "plants",
   "n": "Plants & garden",
   "c": "subject"
  },
  {
   "s": "pets",
   "n": "Pets & animals",
   "c": "subject"
  },
  {
   "s": "foodie",
   "n": "Foodie & kitchen",
   "c": "subject"
  },
  {
   "s": "snarky",
   "n": "Snarky & sarcastic",
   "c": "mood"
  },
  {
   "s": "wholesome",
   "n": "Wholesome & sweet",
   "c": "mood"
  },
  {
   "s": "nostalgic",
   "n": "Nostalgic",
   "c": "mood"
  },
  {
   "s": "bold",
   "n": "Bold & loud",
   "c": "mood"
  },
  {
   "s": "playful",
   "n": "Playful & whimsical",
   "c": "mood"
  },
  {
   "s": "groovy",
   "n": "Groovy",
   "c": "style"
  },
  {
   "s": "varsity",
   "n": "Varsity & collegiate",
   "c": "style"
  },
  {
   "s": "badge",
   "n": "Badge & emblem",
   "c": "style"
  },
  {
   "s": "coquette",
   "n": "Coquette",
   "c": "style"
  },
  {
   "s": "cottagecore",
   "n": "Cottagecore",
   "c": "style"
  },
  {
   "s": "bookish",
   "n": "Books & reading",
   "c": "subject"
  },
  {
   "s": "ocean",
   "n": "Ocean & marine",
   "c": "subject"
  },
  {
   "s": "travel",
   "n": "Travel & wanderlust",
   "c": "subject"
  },
  {
   "s": "celestial",
   "n": "Celestial & cosmic",
   "c": "subject"
  },
  {
   "s": "spooky",
   "n": "Spooky & Halloween",
   "c": "subject"
  },
  {
   "s": "festive",
   "n": "Festive & holiday",
   "c": "subject"
  },
  {
   "s": "autumn",
   "n": "Autumn & fall",
   "c": "subject"
  },
  {
   "s": "outdoors",
   "n": "Outdoorsy",
   "c": "subject"
  },
  {
   "s": "ai",
   "n": "AI",
   "c": "subject"
  },
  {
   "s": "office",
   "n": "Office & work life",
   "c": "subject"
  },
  {
   "s": "modern",
   "n": "Modern & minimal",
   "c": "style"
  },
  {
   "s": "cartoon",
   "n": "Cartoon",
   "c": "style"
  },
  {
   "s": "romantic",
   "n": "Romantic",
   "c": "mood"
  }
 ],
 "vibecats": [
  {
   "s": "mood",
   "n": "Moods"
  },
  {
   "s": "style",
   "n": "Styles"
  },
  {
   "s": "subject",
   "n": "Subjects"
  }
 ]
};
